export const DRIFT_DEBUG_FRAME_LOGGING_PARAM = 'driftDebugFrame'
export const DRIFT_DEBUG_LOGGING_PARAM = 'driftEnableLog'
export const DRIFT_LOGGING_LIMITING = 0.05

export const DRIFT_SENTRY_CONFIG_DEFAULT = {
  forceLogging: false,
  limit: DRIFT_LOGGING_LIMITING
}
